import { render, staticRenderFns } from "./CInfiniteScrollList.vue?vue&type=template&id=2bb77f70&"
import script from "./CInfiniteScrollList.vue?vue&type=script&lang=ts&"
export * from "./CInfiniteScrollList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports